/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MerchantAccountsOnboardingTesting {
    'use strict';

    export class MerchantAccountsOnboardingTestingContext extends Meevo.Components.CommonClasses.CommonContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $scope: angular.IScope,
            protected $translate: angular.translate.ITranslateService,
            protected $mdDialog: ng.material.IDialogService,
            protected $q: angular.IQService,
            protected $rootScope: ng.IRootScopeService) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.merchantAccount;
            this.sectionTemplatePath = "app/plugins/merchantAccountsOnboardingTesting/sectionViews/";
            this.initializeSections();
        }

        initializeSections(): void {
            let baseSectionProps: Meevo.Model.ISectionParamsCommonDataService = {
                sectionId: 0,
                displayNameContentKey: 'SECTION_MAIN',
                template: 'main.html',
                isPrimarySection: true,
                handlesOwnCrud: false,
                baseEndpoint: this.baseEndpoint,
                sectionEndpoint: "OnboardingTestConfiguration",
                loggingService: this.loggingService,
                identityService: this.identityService,
                dataService: this.dataService,
                noun: Meevo.Model.NounEnum.MerchantAccount,
                busyService: this.busyService,
            };

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.REGISTER_MERCHANTACCOUNT + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {

                this.sections.push(new TestConfigurationOnboardingSection(_.extend({}, baseSectionProps,
                {
                    sectionSecurityKey: this.securityKeys.REGISTER_MERCHANTACCOUNT + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                }), this.modalService, this.$rootScope, this.appSettings, this.$translate, this.$q, this));
            }

            this.activate();         
        }

        initializeHeader(model: any): void { } 
    }
}
